module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "35%"
    },
    attrs: {
      "label": "品牌名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "title": _vm.name,
      "placeholder": "请输入品牌名称 (20字以内)",
      "maxlength": "20"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("品牌管理")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addOrEditBrand()
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.Id,
            "label": scope.row.Id
          }
        }, [_vm._v(_vm._s(scope.row.Id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.Name,
            "label": scope.row.Name
          }
        }, [_vm._v(_vm._s(scope.row.Name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "创建时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.CTime,
            "label": scope.row.CTime
          }
        }, [_vm._v(_vm._s(scope.row.CTime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作记录",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "action_container",
          on: {
            "click": function($event) {
              return _vm.endViews(scope)
            }
          }
        }, [_vm._v("查看操作记录")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "action_container",
          on: {
            "click": function($event) {
              return _vm.addOrEditBrand(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v("编辑\r\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "visible": _vm.dialogTable,
      "before-close": _vm.cancelForm,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTable = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('ul', {
          staticClass: "drawer_title"
        }, [_c('li', [_vm._v(_vm._s(_vm.record))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": _vm.cancelForm
          }
        }, [_vm._v("关 闭")])], 1)]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "drawer_div"
  }, [_c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.gridData,
      "height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "OperationDes",
      "label": "操作类型",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "OperatorName",
      "label": "操作人",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "CTime",
      "label": "操作时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('template', {
    slot: "append"
  }, [_c('div', {
    staticClass: "scrollingTips"
  }, [(_vm.loading) ? _c('p', [_vm._v("正在加载")]) : _vm._e(), _vm._v(" "), (_vm.noMore) ? _c('p', [_vm._v("没有更多了")]) : _vm._e()])])], 2)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "add_order_cancle",
    attrs: {
      "title": "品牌管理",
      "center": true,
      "width": "30%",
      "visible": _vm.isToExamine
    },
    on: {
      "update:visible": function($event) {
        _vm.isToExamine = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "品牌名称:",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "maxlength": "20",
      "placeholder": "请输入品牌名称 (20字以内)"
    },
    model: {
      value: (_vm.brandName),
      callback: function($$v) {
        _vm.brandName = $$v
      },
      expression: "brandName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌Logo:",
      "label-width": "80px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    staticStyle: {
      "height": "80px"
    },
    attrs: {
      "action": "",
      "accept": ".png, .jpg",
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.Thumbnail) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.Thumbnail
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/aicon15_09.jpg")
    }
  }), _vm._v(" 尺寸必须为90px*36px，支持png、jpg格式\r\n        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticClass: "el-button el-button--default cancle normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isToExamine = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "el-button el-button--default search_btn normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editSubmit()
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f3ebe386!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/brandManagement.vue
// module id = 1757
// module chunks = 3